function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9 1.091v14.311a1 1 0 00-.43.097l-3.79 1.802a1 1 0 01-1.42-1.032l.543-4.161a1 1 0 00-.266-.817L.752 8.244a1 1 0 01.543-1.671l4.125-.77a1 1 0 00.695-.504l2.007-3.686A1 1 0 019 1.091z"
}));